// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application[data-v-4d570882]{background-color:var(--v-background-light-base)!important}", ""]);
// Exports
module.exports = exports;
